module.exports = __webpack_public_path__ + "static/img/awards-1.cd02e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home-pics/awards-1.jpg
// module id = vXj8
// module chunks = 0